type Box = { left: number; top: number; width: number; height: number };

/**
 * Header menus open as a circle growing out of the menu button and close back into it.
 * The centre is the button's centre relative to the panel; the radius reaches the panel's farthest corner.
 */
export function menuRevealGeometry(button: Box | null | undefined, panel: Box) {
  if (!button || (!button.width && !button.height)) return undefined;
  const x = button.left + button.width / 2 - panel.left;
  const y = button.top + button.height / 2 - panel.top;
  const radius = Math.max(
    Math.hypot(x, y),
    Math.hypot(panel.width - x, y),
    Math.hypot(x, panel.height - y),
    Math.hypot(panel.width - x, panel.height - y),
  );
  return { x: Math.round(x), y: Math.round(y), radius: Math.ceil(radius) };
}

/** Writes the circle onto the panel as `--re-reveal-x/-y/-r`, which the menu's clip-path animation reads. */
export function setMenuReveal(
  panel: HTMLElement | null | undefined,
  button: Element | null | undefined,
): boolean {
  if (!panel) return false;
  const geometry = menuRevealGeometry(
    button?.getBoundingClientRect(),
    panel.getBoundingClientRect(),
  );
  if (!geometry) return false;
  panel.style.setProperty("--re-reveal-x", `${geometry.x}px`);
  panel.style.setProperty("--re-reveal-y", `${geometry.y}px`);
  panel.style.setProperty("--re-reveal-r", `${geometry.radius}px`);
  return true;
}
